export const patternsInfo = [
    {
        name: 'Hammer',
        slogan: 'hammer',
        type: 'candlestick',
        description: `<div>
      <strong>Hammer</strong> — це розворотна свічкова модель, яка виникає після зниження і сигналізує про потенційне зростання. Вона має маленьке тіло і довгий нижній хвіст.
    </div>`
    },
    {
        name: 'Bullish Engulfing',
        slogan: 'bullishEngulfing',
        type: 'candlestick',
        description: `<div>
      <strong>Bullish Engulfing</strong> — це сигнал розвороту вгору, коли бичача свічка повністю поглинає попередню ведмежу. Часто виникає після низхідного тренду.
    </div>`
    },
    {
        name: 'Bearish Engulfing',
        slogan: 'bearishEngulfing',
        type: 'candlestick',
        description: `<div>
      <strong>Bearish Engulfing</strong> — сигнал розвороту вниз. Ведмежа свічка перекриває попередню бичачу, вказуючи на зміну тренду.
    </div>`
    },
    {
        name: 'Shooting Star',
        slogan: 'shootingStar',
        type: 'candlestick',
        description: `<div>
      <strong>Shooting Star</strong> — свічка з маленьким тілом і довгим верхнім хвостом. Показує слабкість покупців і можливий розворот вниз.
    </div>`
    },
    {
        name: 'Doji',
        slogan: 'doji',
        type: 'candlestick',
        description: `<div>
      <strong>Doji</strong> — свічка з майже рівною ціною відкриття і закриття. Символізує нерішучість на ринку.
    </div>`
    },
    {
        name: 'Morning Star',
        slogan: 'morningStar',
        type: 'candlestick',
        description: `<div>
      <strong>Morning Star</strong> — бичачий розворотний патерн із трьох свічок. Включає спадну свічку, маленьку нейтральну і зростаючу свічку.
    </div>`
    },
    {
        name: 'Evening Star',
        slogan: 'eveningStar',
        type: 'candlestick',
        description: `<div><strong>Evening Star</strong> — ведмежий розворотний патерн з 3 свічок. Бичача свічка, маленька зірка, потім ведмежа — сигнал розвороту вниз.</div>`
    },
    {
        name: 'Three White Soldiers',
        slogan: 'threeWhiteSoldiers',
        type: 'candlestick',
        description: `<div><strong>Three White Soldiers</strong> — три послідовні бичачі свічки з вищими закриттями. Сильний сигнал продовження зростання.</div>`
    },
    {
        name: 'Three Black Crows',
        slogan: 'threeBlackCrows',
        type: 'candlestick',
        description: `<div><strong>Three Black Crows</strong> — три послідовні ведмежі свічки з нижчими закриттями. Один з найнадійніших ведмежих сигналів.</div>`
    },
    {
        name: 'Bullish Harami',
        slogan: 'bullishHarami',
        type: 'candlestick',
        description: `<div><strong>Bullish Harami</strong> — маленька бичача свічка всередині великої ведмежої. Сигнал вичерпання ведмежого руху.</div>`
    },
    {
        name: 'Bearish Harami',
        slogan: 'bearishHarami',
        type: 'candlestick',
        description: `<div><strong>Bearish Harami</strong> — маленька ведмежа свічка всередині великої бичачої. Сигнал вичерпання зростання.</div>`
    },
    {
        name: 'Dark Cloud',
        slogan: 'darkCloud',
        type: 'candlestick',
        description: `<div>
      <strong>Dark Cloud Cover</strong> — розворотний ведмежий патерн. З’являється після зростання. Друга свічка відкривається вище попередньої, але закривається глибоко в її тілі.
    </div>`
    },
    {
        name: 'Double Top',
        slogan: 'doubleTop',
        type: 'candlestick',
        description: `<div>
      <strong>Double Top</strong> — графічна модель розвороту вниз. Формується двома піками на однаковому рівні.
    </div>`
    },
    {
        name: 'Double Bottom',
        slogan: 'doubleBottom',
        type: 'candlestick',
        description: `<div>
      <strong>Double Bottom</strong> — модель розвороту вгору. Складається з двох мінімумів, між якими — невелике зростання.
    </div>`
    },
    {
        name: "Head and Shoulders",
        slogan: "headAndShoulders",
        type: "chart",
        description: "<p>Класичний патерн розвороту вниз. Складається з трьох вершин: голова та два плеча.</p>",
        tooltip: false
    },
    {
        name: "Inverse Head and Shoulders",
        slogan: "inverseHeadAndShoulders",
        type: "chart",
        description: "<p>Патерн розвороту вгору після низхідного тренду.</p>",
        tooltip: false
    },
    {
        name: "Triangle",
        slogan: "triangle",
        type: "chart",
        description: "<p>Консолідація, що веде до прориву. Може бути симетричним, висхідним або низхідним.</p>",
        tooltip: false
    },
    {
        name: "Bullish Pennant",
        slogan: "bullishPennant",
        type: "chart",
        description: "<p>Фігура продовження тренду. Маленький трикутник після стрімкого росту.</p>",
        tooltip: false
    },
    {
        name: "Bearish Pennant",
        slogan: "bearishPennant",
        type: "chart",
        description: "<p>Фігура продовження тренду вниз після сильної просадки.</p>",
        tooltip: false
    },
    {
        name: "Falling Wedge",
        slogan: "fallingWedge",
        type: "chart",
        description: "<p>Фігура розвороту або продовження. Очікується прорив вгору.</p>",
        tooltip: false
    },
    {
        name: "Rising Wedge",
        slogan: "risingWedge",
        type: "chart",
        description: "<p>Фігура розвороту або продовження. Очікується прорив вниз.</p>",
        tooltip: false
    },
    {
        name: "Cup and Handle",
        slogan: "cupAndHandle",
        type: "chart",
        description: "<p>Патерн продовження зростання після утворення чашки і короткочасного відкату.</p>",
        tooltip: false
    },
    {
        name: "Ascending Triangle",
        slogan: "ascendingTriangle",
        type: "chart",
        description: "<p>Бичачий патерн: горизонтальний опір + зростаюча підтримка. Очікується прорив вгору.</p>",
        tooltip: false
    },
    {
        name: "Descending Triangle",
        slogan: "descendingTriangle",
        type: "chart",
        description: "<p>Ведмежий патерн: горизонтальна підтримка + спадаючий опір. Очікується прорив вниз.</p>",
        tooltip: false
    },
    {
        name: "Bull Flag",
        slogan: "bullFlag",
        type: "chart",
        description: "<p>Патерн продовження зростання. Паралельний канал вниз після стрімкого росту.</p>",
        tooltip: false
    },
    {
        name: "Bear Flag",
        slogan: "bearFlag",
        type: "chart",
        description: "<p>Патерн продовження падіння. Паралельний канал вгору після стрімкого падіння.</p>",
        tooltip: false
    }
];
